export default __webpack_public_path__ + "b46d7bd8ef627380042668cf319d5bd9.png";